import { render, staticRenderFns } from "./RegisterMobile.vue?vue&type=template&id=4965b1d2&scoped=true"
import script from "./RegisterMobile.vue?vue&type=script&lang=js"
export * from "./RegisterMobile.vue?vue&type=script&lang=js"
import style0 from "./RegisterMobile.vue?vue&type=style&index=0&id=4965b1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4965b1d2",
  null
  
)

export default component.exports